import {get} from '@/utils/request'
const indexApi = {
  getErrorInfo: function () {
    return get('/member/index/getError', {})
  },
  /* 首页管理_清空系统报错信息 */
  deleteMsg: function () {
    return get('/member/index/delError', {})
  },
  /* 首页管理_获取商户是否可用、过期时间等信息 */
  getSysInfo: function () {
    return get('/member/index/info')
  }
}

export default indexApi



// WEBPACK FOOTER //
// ./src/api/index.js